<h1>Primary</h1>
<div class="buttons">
  <app-button class="button" text="Primary" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Primary" classes="bold" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Disabled" [disabled]="true" (onClick)="submit($event)"></app-button>
</div>
<div class="buttons">
  <app-button class="button" text="Secondary" classes="secondary" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Secondary" classes="secondary bold" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Secondary" classes="secondary" [disabled]="true" (onClick)="submit($event)"></app-button> 
</div>
<div class="buttons">
  <app-button class="button" text="Success" classes="success" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Success" classes="success bold" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Success" classes="success" [disabled]="true" (onClick)="submit($event)"></app-button> 
</div>
<div class="buttons">
  <app-button class="button" text="Danger" classes="danger" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Danger" classes="danger bold" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Danger" classes="danger" [disabled]="true" (onClick)="submit($event)"></app-button> 
</div>
<div class="buttons">
  <app-button class="button" text="Link" classes="link" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Link" classes="link bold" (onClick)="submit($event)"></app-button> 
  <app-button class="button" text="Link" classes="link" [disabled]="true" (onClick)="submit($event)"></app-button> 
</div>
<div class="buttons">
  <app-button class="button" text="Left Icon" styleType="pi" type="pi" icon="filter" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Right Icon" styleType="pi" type="pi" icon="filter" iconPos="right" (onClick)="submit($event)"></app-button>
  <app-button class="button" styleType="pi" type="pi" icon="filter" (onClick)="submit($event)"></app-button>
  <app-button class="button" styleType="pi" type="pi" icon="filter" [disabled]="true" (onClick)="submit($event)"></app-button>
</div>
<div class="buttons">
  <app-button class="button" text="Large" classes="large" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Large" classes="large bold" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Default" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Default" classes="bold" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Small" classes="small" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Small" classes="small bold" (onClick)="submit($event)"></app-button>
</div>
<div class="buttons">
  <app-button class="button" text="Transparent" classes="transparent" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Transparent Success" classes="transparent success" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Transparent Danger" classes="transparent danger" (onClick)="submit($event)"></app-button>
  <app-button class="button" text="Transparent" classes="transparent" [disabled]="true" (onClick)="submit($event)"></app-button>
</div>
<div class="buttons">
  <app-button class="button" styleType="pi" type="pi" icon="filter" classes="transparent large" (onClick)="submit($event)"></app-button>
  <app-button class="button" styleType="pi" type="pi" icon="filter" classes="transparent" (onClick)="submit($event)"></app-button>
  <app-button class="button" styleType="pi" type="pi" icon="filter" classes="transparent small" (onClick)="submit($event)"></app-button>
  <app-button class="button" styleType="pi" type="pi" icon="filter" classes="transparent" [disabled]="true" (onClick)="submit($event)"></app-button>
</div>

<h1>Split Button Example</h1>
<div class="buttons">
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" classes="bold" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" [disabled]="true" (onClick)="submit($event)"></app-split-button>
</div>
<div class="buttons">
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" classes="secondary" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" classes="secondary bold" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" [disabled]="true" classes="secondary" (onClick)="submit($event)"></app-split-button>
</div>
<div class="buttons">
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" classes="danger" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" classes="danger bold" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Save" [model]="splitButtonOptions" [disabled]="true" classes="danger" (onClick)="submit($event)"></app-split-button>
</div>
<div class="buttons">
  <app-split-button class="button" text="Large" [model]="splitButtonOptions" classes="large" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Large" [model]="splitButtonOptions" classes="large bold" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Default" [model]="splitButtonOptions" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Default" [model]="splitButtonOptions" classes="bold" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Small" [model]="splitButtonOptions" classes="small" (onClick)="submit($event)"></app-split-button>
  <app-split-button class="button" text="Small" [model]="splitButtonOptions" classes="small bold" (onClick)="submit($event)"></app-split-button>
</div>

<h1>Back Button</h1>
<app-back-button></app-back-button>